import { clearAdminSession, getAdminToken } from "./adminAuthApi";

const API_BASE_URL = (
  process.env.REACT_APP_ADMIN_API_BASE_URL ||
  "http://secondbite-manage.localhost/admin-api/v1"
).replace(/\/+$/, "");

const request = async (path, options = {}) => {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      ...options,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getAdminToken()}`,
        ...(options.body ? { "Content-Type": "application/json" } : {}),
        ...options.headers,
      },
    });
  } catch {
    throw new Error("Unable to connect to the SecondBite backend.");
  }
  const payload = await response.json().catch(() => null);
  if (response.status === 401) {
    clearAdminSession();
    window.location.replace("/login");
    throw new Error("Your session has expired.");
  }
  if (!response.ok || !payload?.success) {
    const validationMessage = payload?.errors
      ? Object.values(payload.errors).flat().find(Boolean)
      : null;
    throw new Error(validationMessage || payload?.message || "Request failed.");
  }
  return payload;
};

export const listAdminOutlets = async (merchantId) =>
  (await request(`/merchants/${merchantId}/outlets`)).data;

export const createAdminOutlet = async (merchantId, data) =>
  (await request(`/merchants/${merchantId}/outlets`, {
    method: "POST",
    body: JSON.stringify(data),
  })).data;

export const updateAdminOutlet = async (merchantId, outletId, data) =>
  (await request(`/merchants/${merchantId}/outlets/${outletId}`, {
    method: "PUT",
    body: JSON.stringify(data),
  })).data;

export const deleteAdminOutlet = async (merchantId, outletId) =>
  request(`/merchants/${merchantId}/outlets/${outletId}`, { method: "DELETE" });

const outletStatusPayload = (outlet) => ({
  name: outlet.name,
  phone: outlet.phone || null,
  email: outlet.email || null,
  address: outlet.address,
  city: outlet.city,
  state: outlet.state || "Sarawak",
  postcode: outlet.postcode,
  latitude: outlet.latitude || null,
  longitude: outlet.longitude || null,
  google_map_url: outlet.google_map_url || null,
  platform_base_fee: Number(outlet.platform_base_fee || 0),
  platform_percentage_fee: Number(outlet.platform_percentage_fee || 0),
  monthly_subscription_fee:
    outlet.monthly_subscription_fee === "" || outlet.monthly_subscription_fee == null
      ? null
      : Number(outlet.monthly_subscription_fee),
  accepting_orders: false,
  status: 0,
  open_time: outlet.open_time || null,
  close_time: outlet.close_time || null,
  last_order_time: outlet.last_order_time || null,
});

export const inactivateAdminOutlets = async (merchantId) => {
  const result = await listAdminOutlets(merchantId);
  const outlets = result?.outlets || [];
  await Promise.all(
    outlets
      .filter((outlet) => Number(outlet.status) !== 0)
      .map((outlet) => updateAdminOutlet(merchantId, outlet.id, outletStatusPayload(outlet)))
  );
  return outlets.length;
};
